import React, { FunctionComponent } from "react";
import { connect, MapStateToProps } from "react-redux";

import { EntityType } from "@multiweb/picasso";
import { IAppState } from "@multiweb/types/react";
import { createGetSelectedWfElement } from "../../selectors";
import { WorkflowEditorProps } from "../../types";
import { ActivityPropertyPanel } from "./ActivityPropertyPanel";
import { GeneralPropertyPanel } from "./GeneralPropertyPanel";
import { TransitionPropertyPanel } from "./TransitionPropertyPanel";

type PropertyPanelProps = {
    readonly selectedPicassoEntityType: EntityType | undefined;
    readonly picassoIndex: number | undefined;
} & WorkflowEditorProps;

const PropertyPanelComponent: FunctionComponent<PropertyPanelProps> = ({ hostKey, selectedPicassoEntityType, picassoIndex }) => {
    if (selectedPicassoEntityType == null)
        return <GeneralPropertyPanel {...{ hostKey }} />;
    if (selectedPicassoEntityType === EntityType.component && picassoIndex !== undefined)
        return <ActivityPropertyPanel picassoComponentId={picassoIndex} {...{ hostKey }} />;
    if (selectedPicassoEntityType === EntityType.link && picassoIndex !== undefined)
        return <TransitionPropertyPanel picassoLinkId={picassoIndex} {...{ hostKey }} />;
    return null;
};

type StateProps = Pick<PropertyPanelProps, "selectedPicassoEntityType" | "picassoIndex">;

const createMapStateToProps: () => MapStateToProps<StateProps, WorkflowEditorProps, IAppState> = () => {
    const getSelectedWfElement = createGetSelectedWfElement();

    return (state, { hostKey }) => {
        const selectedWfEntity = getSelectedWfElement(state, hostKey);

        return {
            selectedPicassoEntityType: selectedWfEntity?.type,
            picassoIndex: selectedWfEntity?.index,
        };
    };
};

export const PropertyPanel = connect(createMapStateToProps)(PropertyPanelComponent);
